module.exports = __webpack_public_path__ + "static/img/2_4@2x.bfc782f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/2_4@2x.png
// module id = lod2
// module chunks = 8